<template>
  <section-container>
    <div class="w-full flex justify-center items-center flex-wrap p-2">
      <div class="w-full lg:w-1/3 flex flex-wrap flex-col">
        <h3 class="text-3xl font-bold mb-2">Categorias</h3>
        <h4 class="text-xl mb-5">Gerencie suas categorias</h4>
        <div class="mt-5">
          <router-link
            class="px-6 py-4 text-md rounded font-bold text-white bg-indigo-600 hover:bg-indigo-700 border-indigo-500"
            :to="{ name: 'store.category.create' }"
          >
            <font-awesome-icon icon="plus" class="mr-2" />
            Adicionar categoria
          </router-link>
        </div>
      </div>
      <div class="w-full lg:w-2/3 flex justify-center items-center px-4 my-2">
        <img
          src="@/assets/img/categories.png"
          alt=""
          width="650px"
          class="h-auto overflow-hidden"
        />
      </div>
    </div>
    <content-e>
      <div class="w-full p-2" v-if="!categories">
        <alert-empty></alert-empty>
      </div>
      <ui-confirm
        ref="scaleDownConfirm"
        title="Você gostaria de remover?"
        transition="scale-down"
        confirmButtonText="Deletar"
        type="danger"
        confirmButtonIcon="delete"
        @confirm="onConfirm"
        @deny="onDeny"
        >Você gostaria de remover?</ui-confirm
      >
      <div
        v-for="category in categories"
        :key="category.id"
        class="w-full md:w-1/3 p-2"
      >
        <div class="bg-white shadow-2l p-6 rounded relative">
          <h2 class="font-bold text-xl">{{ category.name }}</h2>
          <div class="mt-4 text-gray-500">
            <span
              class="bg-indigo-100 text-indigo-600 px-3 py-2 rounded-full text-sm mr-2"
            >
              <font-awesome-icon icon="box" class="" />
            </span>
            <small>Produtos na categoria: {{ category.products_count }}</small>
          </div>
          <div class="my-5 absolute top-0 right-0">
            <router-link
              :to="{
                name: 'store.category.show',
                params: { category: category.id }
              }"
              class="mr-1 text-xl relative inline-block px-3 py-2 font-bold text-blue-500 leading-tight bg-blue-100 rounded-full"
            >
              <font-awesome-icon icon="pen" />
              <ui-tooltip position="bottom" animation="fade">Editar</ui-tooltip>
            </router-link>
            <span
              @click="onDeleteCategory(category.id)"
              :to="{ name: 'orders.show', params: { id: category.id } }"
              class="cursor-pointer mr-1 text-xl relative inline-block px-3 py-2 font-bold text-red-500 leading-tight bg-red-100 rounded-full"
            >
              <font-awesome-icon icon="trash-alt" />
              <ui-tooltip position="bottom" animation="fade"
                >Remover</ui-tooltip
              >
            </span>
          </div>
        </div>
      </div>
    </content-e>
  </section-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      categories: {},
      category_deleted: null
    }
  },
  methods: {
    showConfirm(ref, token) {
      this.category_deleted = token
      this.$refs[ref].open()
    },
    hideConfirm(ref) {
      this.$refs[ref].close()
    },
    async doLoadCategories() {
      const categories = await this.$store.dispatch(
        'store/LOAD_CATEGORIES_BY_STORE',
        this.$store.state.store.id
      )
      this.categories = categories.data
    },
    onDeleteCategory(e) {
      this.showConfirm('scaleDownConfirm', e)
    },
    onConfirm() {
      this.$store
        .dispatch('store/DELETE_CATEGORY_BY_ID', this.category_deleted)
        .then((response) => {
          this.$toasted.success(response.message, {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
          this.doLoadCategories()
        })
    },
    onDeny() {
      this.category_deleted = null
    }
  },
  async beforeMount() {
    await this.doLoadCategories()
  }
}
</script>

<style>
</style>
